// components/BranchCard.jsx
import React from "react";
import Spinner from "../../spinner/Spinner";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { ReactComponent as ArrowLeftCircleLeftFill } from "bootstrap-icons/icons/arrow-left-circle-fill.svg";
import { ReactComponent as ArrowRightCircleLeftFill } from "bootstrap-icons/icons/arrow-right-circle-fill.svg";
const ProductCard = ({
    // loading,
    products = [],
    currentPage,
    paginate,
    hasPrevPage,
    hasNextPage,
}) => {
    // if (loading) return <Spinner loading={loading} />;

    return (
        <>
            {/* Product Card Section */}
            <section className="text-gray-600 body-font">
                <div className="container px-1 py-2 mx-auto">
                    <div className="flex flex-wrap -m-2">
                        {products?.length > 0 ? (
                            products.map((product, index) => (
                                <div key={index} className="p-2 lg:w-1/4 md:w-1/2 w-full">
                                    <div className="h-full flex items-center border-lGrey border shadow-sm p-4 rounded-lg">
                                        <div className="flex-grow">
                                            <h2 className="text-orange1 title-font font-medium uppercase">
                                                {product.product_name}
                                            </h2>
                                            <p className="text-sm text-gray-600">
                                                Category: {product.category || "N/A"}
                                            </p>
                                            <p className="text-sm text-gray-600">
                                                Revenue: {CurrencyFormatter(product.total_revenue || "0.00")}
                                            </p>
                                            <p className="text-sm text-gray-600">
                                                Transactions: {product.transactions || "0"}
                                            </p>
                                            <p className="text-sm text-gray-600">
                                                Total Quantity: {product.total_quantity || "0"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="w-full text-center text-lg py-5">
                                No Branch Product performance data available.
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* Pagination Controls */}
            {/* <section className="py-3">
                <div className="flex justify-end mt-6">
                    <nav aria-label="Page navigation">
                        <ul className="pagination flex mx-auto">
                            <li className={`page-item ${!hasPrevPage ? "disabled" : ""}`}>
                                <button
                                    className="text-dGrey3 bg-orange1 border-0 py-1 px-2 rounded mr-3"
                                    onClick={() => paginate(currentPage - 1)}
                                    disabled={!hasPrevPage}
                                >
                                    <span className="flex mx-2 mt-1">
                                        <ArrowLeftCircleLeftFill className="w-5 h-5 mr-2" />
                                        Prev
                                    </span>
                                </button>
                            </li>
                            <li className={`page-item ${!hasNextPage ? "disabled" : ""}`}>
                                <button
                                    className="text-dGrey3 bg-orange1 border-0 py-1 px-2 rounded"
                                    onClick={() => paginate(currentPage + 1)}
                                    disabled={!hasNextPage}
                                >
                                    <span className="flex mx-2 mt-1">
                                        <ArrowRightCircleLeftFill className="w-5 h-5 mr-2" />
                                        Next
                                    </span>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </section> */}
        </>
    );
};

export default ProductCard;
